import domready from "domready"
import "./style.css"
import Color from "./Color";
import weightedRandom from "./weightedRandom";
import loadImages from "./loadImages";
import Rect from "./Rect";

const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;

const config = {
    width: 0,
    height: 0
};

/**
 * @type CanvasRenderingContext2D
 */
let ctx;
let canvas;
let shadowImages;

function norm(number)
{
    const n = number - (number | 0);
    return n < 0 ? 1 + n : n;
}

const shadowBase = Color.from("#1d264c")
const lightBase = Color.from("#fffbde")


const windowCount = weightedRandom([
    2, () => 2,
    1, () => 3,
])

const windowAlign = weightedRandom([
    2, () => 0,
    4, () => 1,
    1, () => 2,
])

const windowCross = weightedRandom([
    4, () => 0,
    1, () => 1,
    1, () => 2,
])

const windowCrossTrip = weightedRandom([
    1, () => 1,
    1, () => 2,
])

const windowShadow = weightedRandom([
    1, () => null,
    1/3, () => "shadow-ball",
    1/3, () => "shadow-boxes2",
    1/3, () => "shadow-boxes",
    1/3, () => "shadow-cat2",
    1/3, () => "shadow-cat3",
    1/3, () => "shadow-cat",
    1/2, () => "shadow-lgbt",
    1/12, () => "shadow-plant10",
    1/12, () => "shadow-plant11",
    1/12, () => "shadow-plant12",
    1/12, () => "shadow-plant2",
    1/12, () => "shadow-plant3",
    1/12, () => "shadow-plant4",
    1/12, () => "shadow-plant5",
    1/12, () => "shadow-plant6",
    1/12, () => "shadow-plant7",
    1/12, () => "shadow-plant8",
    1/12, () => "shadow-plant9",
    1/12, () => "shadow-plant",
])

const windowDecal = weightedRandom([
    1, () => 1,
    1, () => 2,
])


function randomWindow()
{
    const count = windowCount();
    const align = count === 3 ? 0 : windowAlign();
    const cross = align === 2 ? windowCrossTrip() : windowCross()
    const decal = windowDecal()

    const aspect = 0.56 + Math.random() * 0.02

    let wnd = {
        count,
        align,
        cross,
        decal,
        aspect
    };
    console.log("randomWindow", wnd)

    return wnd
    
}


function createBuildingOpts(hue, windowGradient)
{
    let wild = Math.random() < 0.15;

    if (wild)
    {
        return {
            windowGradient,
            color: Color.fromHSL(norm(hue - 0.15 + Math.random() * 0.3) , 0.05 + Math.random() * 0.15, 0.4 + Math.random() * 0.5 ),
            wild

        };
    }
    else
    {
        return {
            windowGradient,
            color: Color.fromHSL(norm(hue - 0.1 + Math.random() * 0.2 + Math.random() < 0.3 ? 0 : 0.5) , 0.05 + Math.random() * 0.05, 0.5 + Math.random() * 0.2 ),
            wnd: randomWindow(),
            wild
        };

    }
}


const RAISED = 0
const RECESSED = 1




function drawWindow(rect, wnd, index, opts)
{
    const { x,y,w,h } = rect

    let shadow = windowShadow();

    ctx.fillStyle = opts.windowGradient
    ctx.fillRect(x,y,w,h)


    if (shadow)
    {
         const moveX = NO_MOVE[shadow] ? 0 : 10

        let image = shadowImages.get(shadow);
        ctx.drawImage( image, 0|(x - moveX/2 + Math.random() * moveX) ,y,w,h)
        ctx.globalAlpha = 1

    }



}

let fsTmp
/**
 * @type CanvasRenderingContext2D
 */
let fsCtx
let fsCTmp = new Color(0,0,0)

function fakeShadows(rect, color, px, py, renderFn, offX = 2, offY = 2)
{
    const {x,y,w,h} = rect

//    if (!fsTmp)
    {
        fsTmp = document.createElement("canvas")
        fsCtx = fsTmp.getContext("2d")
        fsTmp.width = w 
        fsTmp.height = h
    }

    fsCtx.globalCompositeOperation = "source-over"
    fsCtx.clearRect(x,y,w,h)
    fsCtx.fillStyle = color.mix(shadowBase, 0.4, fsCTmp).toRGBHex()
    renderFn(fsCtx)

    drawImageLine(fsTmp, x,y,x + offX, y + offY)

    fsCtx.globalCompositeOperation = "source-atop"
    fsCtx.fillStyle = color.mix(lightBase, 0.3, fsCTmp).toRGBHex()
    fsCtx.fillRect(0,0,w,h)
    drawImageLine(fsTmp, x,y,x - offX, y - offY)


    fsCtx.fillStyle = color.toRGBHex()
    fsCtx.fillRect(0,0,w,h)
    ctx.drawImage(fsTmp, px, py)
    fsCtx.globalCompositeOperation = "source-over"

}


function drawImageLine(image, x0, y0, x1, y1)
{
    const dx = Math.abs(x1 - x0);
    const dy = Math.abs(y1 - y0);
    const sx = (x0 < x1) ? 1 : -1;
    const sy = (y0 < y1) ? 1 : -1;
    let err = dx - dy;

    while (true)
    {
        ctx.drawImage(image, x0,y0)

        if ((x0 === x1) && (y0 === y1))
        {
            break;
        }
        const e2 = 2 * err;
        if (e2 > -dy)
        {
            err -= dy;
            x0 += sx;
        }
        if (e2 < dx)
        {
            err += dx;
            y0 += sy;
        }
    }
}


function drawLevel(rect, decoCtx, opts)
{
    const { x,y,w,h } = rect
    let { color, wild, wnd } = opts
    if (wild)
    {
        wnd = randomWindow()
    }

    ctx.fillStyle = color.toRGBHex()
    ctx.fillRect(x,y,w,h)

    const { count, align, cross, decal, aspect } = wnd

    const windowBase = Math.floor(w / count)

    const meter = h/3;
    opts.meter

    for (let i=0; i < count; i++)
    {
        const wh = h - meter * 1.6
        const ww = wh * aspect

        const windowRect = new Rect(
            x + windowBase * i + (align === 2 ? (i === 0 ? w/2 - ww : 0) : windowBase/2 - ww/2),
            y + meter * 0.6,
            ww,
            wh
        )
        drawWindow(windowRect, wnd, i, opts)


        let r = new Rect(rect.x, y + wh - meter, rect.w, meter)
        let r2 = r.offset(10)

        console.log("R", r, "offset", r2)

        fakeShadows(rect, opts.color, x, y, ctx => {

            let r2 = rect.offset(10)
            let x = r2.x - rect.x;
            let y = r2.y - rect.y;
            ctx.fillRect(x, y,r2.w,r2.h)


            ctx.globalCompositeOperation = "destination-out"

            const circleCutout = (x, y) => {
                const r = 20
                ctx.beginPath()
                ctx.moveTo(x + r, y)
                ctx.arc(x, y, r, 0, TAU, true)
                ctx.fill()
            };


            circleCutout(          x,y);
            circleCutout(x + r2.w, y + r2.h);
            circleCutout(x          ,y+ r2.h);
            circleCutout(x + r2.w, y);

            ctx.globalCompositeOperation = "source-over"

        })

        fakeShadows(rect, opts.color, x, y, ctx => {

            let cx = rect.w/2
            let cy = rect.h/2
            
            let radius = Math.round(rect.w / 8);
            ctx.beginPath()
            ctx.moveTo( cx + radius , cy)
            ctx.arc(cx, cy, radius, 0, TAU, true)
            ctx.fill()
        }, -2, -2)

    }

    ctx.strokeStyle = "#000"
    ctx.strokeRect(x,y,w,h)

}

const black = new Color(0,0,0)

let skyGradient

const NO_MOVE = {
    "shadow-lgbt": 1
}

domready(
    () => {

        return Promise.all([
            loadImages([
                "media/shadow-ball.png",
                "media/shadow-boxes2.png",
                "media/shadow-boxes.png",
                "media/shadow-cat2.png",
                "media/shadow-cat3.png",
                "media/shadow-cat.png",
                "media/shadow-lgbt.png",
                "media/shadow-plant10.png",
                "media/shadow-plant11.png",
                "media/shadow-plant12.png",
                "media/shadow-plant2.png",
                "media/shadow-plant3.png",
                "media/shadow-plant4.png",
                "media/shadow-plant5.png",
                "media/shadow-plant6.png",
                "media/shadow-plant7.png",
                "media/shadow-plant8.png",
                "media/shadow-plant9.png",
                "media/shadow-plant.png",
        ])

        ]).then(([_shadowImages]) => {

            //console.log("Image Map", _shadowImages)

            shadowImages = _shadowImages;

            canvas = document.getElementById("screen");
            ctx = canvas.getContext("2d");

            const width = (window.innerWidth) | 0;
            const height = (window.innerHeight) | 0;

            config.width = width;
            config.height = height;

            canvas.width = width;
            canvas.height = height;

            const generate = () => {
                const preferred = 0|(height * 0.6666)

                const numHouses = Math.floor(width/preferred)

                let preferredHeight = width / 0.5;
                skyGradient = ctx.createLinearGradient(0,0,0,height*2/3)
                skyGradient.addColorStop(0, "#5dbdd8")
                skyGradient.addColorStop(1, "#e6f5f9")

                let top = 0
                ctx.fillStyle = skyGradient
                if (preferredHeight < height)
                {
                    top = height - preferredHeight
                }
                ctx.fillRect(0,0,width, top + height/3)

                const w = Math.round(width / numHouses)

                const decorations = [
                    document.createElement("canvas"),
                    document.createElement("canvas")
                ]

                decorations.forEach(deco => {
                    deco.width = w
                    deco.height = height - top
                })

                const decoCtx = decorations.map( deco => deco.getContext("2d"))
                decoCtx.forEach(ctx => {
                    ctx.clearRect(0, 0, w, ctx.canvas.height);
                })


                const windowGradient = ctx.createLinearGradient(0,top,0,height)
                windowGradient.addColorStop(0, "rgba(0,0,0,0.1)")
                windowGradient.addColorStop(1, "rgba(0,0,0,0.9)")


                const hue = Math.random()
                for (let i=0; i < numHouses; i++)
                {
                    const levelHeight = 0|((height - top)/3)

                    const roof = Math.round(Math.random()) * levelHeight

                    const opts = createBuildingOpts(hue, windowGradient)


                    for (let y = height; y >= roof; y-= levelHeight)
                    {
                        const rect = new Rect(
                            w * i,
                            y,
                            w,
                            levelHeight
                        )
                        drawLevel(rect, decoCtx, opts)

                    }

                    if (roof && Math.random() < 0.5)
                    {
                        ctx.fillStyle = black.toRGBA(0.9)
                        ctx.fillRect(w*i,levelHeight/2, w, levelHeight/2)
                    }

                }

                ctx.fillStyle = lightBase.toRGBA(0.15)
                ctx.fillRect(0,0,width, height)


            }

            generate()

            canvas.addEventListener("click", generate, false)


        })

    }
);
